/* eslint-disable import/no-cycle */
import store from '../../store';
import auth from './auth';
import siteMessages from './siteMessages';
import billing from './billing';
import businesses from './businesses';
import businessUsers from './businessUsers';
import cannedReplies from './cannedReplies';
import config from './config';
import contracts from './contracts';
import creatorProgram from './creatorProgram';
import events from './events';
import invoices from './invoices';
import labels from './labels';
import packages from './packages';
import payments from './payments';
import pepper from './pepper';
import reports from './reports';
import schedules from './schedules';
import sponsorships from './sponsorships';
import users from './users';
import threads from './threads';
import tracking from './tracking';
import validation from './validation';
import promotions from './promotions';
import networks from './networks';

const { location } = window;

/**
 * @description Api url
 * @type {string}
 */
export const apiUrl = `${location.protocol}//${import.meta.env.VUE_APP_API}/api`;

/**
 * @description Max items per page
 * @type {string}
 */
export const maxItemsPerPage = import.meta.env.VUE_APP_API_MAX_ITEMS_PER_PAGE;

/**
 * @description Get token
 * @param token
 * @returns {*}
 */
export const getToken = (token = 'access_token') =>
  store.getters['auth/token'][token];

export default {
  auth,
  siteMessages,
  billing,
  businesses,
  businessUsers,
  cannedReplies,
  config,
  contracts,
  creatorProgram,
  events,
  invoices,
  labels,
  packages,
  payments,
  pepper,
  reports,
  schedules,
  sponsorships,
  threads,
  tracking,
  users,
  validation,
  promotions,
  networks,
};
